/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import WyUtils from '../../../library/wy-utils.js';
import moment from 'moment';
import _ from 'lodash';
import WyChartModule from '../../../library/wy-chart-module.js';

var wyChart = new WyChartModule();

const WyPanelUtils = {
  mapLagends: {
    customerRequested: 'customer requested',
    programmed: 'programmed',
    contained: 'contained',
    handoff: 'handed off',
    resolved: 'resolved',
    abandoned: 'abandoned',
    messagesUnderstood: 'messages understood',
    messagesNotUnderstood: 'messages not understood',
    falsePositive: 'false positives',
    correctClassification: 'correct classification',
    longMessages: 'long messages',
    shortMessages: 'short messages',
    positiveFeedback: 'positive feedback',
    negativeFeedback: 'negative feedback',
    noFeedback: 'no feedback',
    returningCustomers: 'returning customers',
    newCustomers: 'new customers',
    mixedFeedback: 'mixed feedback',
    LCOnly: 'LC Only',
  },

  updateLegendMap(field) {
    if(!this.mapLagends[field.prefix]) {
      this.mapLagends[field.prefix] = field.label;
    }
  },

  dynamicCreateTemplateData: (data, list, listObj) => {
    // data.data[0].columnChartData.traceData.forEach(trace => {
    //   trace.key = "total" + listObj[index].suffix
    // })
    let legends = [];
    listObj.forEach(item => {
      legends.push(item.label)
    })
    data.data[0].columnChartData.legends = legends;
    data.data[0].pieChartData.legends = legends;
    data.legends = legends;
    data.data[0].columnChartData.traceData = [];
    list.forEach((item, index) => {
      // listObj.forEach(item => {
      //   item
      //   let traceObj = {
      //     x: [],
      //     y: [],
      //     width: 0.5,
      //     key: 'total' + item.suffix,
      //     name: item.suffix,
      //     type: 'bar',
      //     marker: {
      //       color: '#8A8EF4',
      //       line: {
      //           color: 'white'
      //       }
      //     }
      //   }
      //   data.data[0].columnChartData.traceData.push(traceObj)
      // })
      let traceObj = {
        x: [],
        y: [],
        key: listObj[index].prefix,
        name: listObj[index].suffix,
        hovertemplate: '',
        type: 'bar',
        marker: {
          color: '#8A8EF4',
          line: {
              color: 'white'
          }
        }
      }
      data.data[0].columnChartData.traceData.push(traceObj)
      data.data[index + 1] = {
        key: item,
        suffixKey: listObj[index].suffix,
        label: listObj[index].label,
        value: '',
        displayValue: '',
        selected: false,
        changeOver30Days: 0,
        changeFromStart: 0,
        prefix:'',
        suffix:'',
        chartData: [],
        trendGraph: '',
        pieChartData: {
          title: listObj[index].label,
          tooltips: listObj[index].label + ', split between conversations contained and handed off.',
          labels: ['Contained', 'Handed off'],
          values: [],
          percent: [],
          displayValue: '',
          legends: ['Contained', 'Handed off'],
        },
        columnChartData: {
          title: listObj[index].label,
          legends: ['Contained', 'Handed off'],
          traceData: [
            {
              x: [],
              y: [],
              name: 'Handed off',
              hovertemplate: '',
              key: 'handoff',
              type: 'bar',
              marker: {
                color: '#4D50E8',
                line: {
                  color: 'white',
                }
              }
            },
            {
              x: [],
              y: [],
              hovertemplate: '',
              name: 'Contained',
              key: 'contained',
              type: 'bar',
              marker: {
                color: '#8A8EF4',
                line: {
                    color: 'white',
                }
              }
            },
            {
              x: [],
              y: [],
              name: 'LC Only',
              hovertemplate: '',
              key: 'LCOnly',
              type: 'bar',
              marker: {
                color: '#4D50E8',
                line: {
                  color: 'white',
                }
              }
            },
            {
              x: [],
              y: [],
              name: 'Positive feedback',
              key: 'positiveFeedback',
              hovertemplate: '',
              type: 'bar',
              marker: {
                color: '#4D50E8',
                line: {
                  color: 'white',
                }
              }
            },
            {
              x: [],
              y: [],
              hovertemplate: '',
              name: 'Negative feedback',
              key: 'negativeFeedback',
              type: 'bar',
              marker: {
                color: '#8A8EF4',
                line: {
                    color: 'white',
                }
              }
            },
            {
              x: [],
              y: [],
              name: 'no feedback',
              key: 'noFeedback',
              hovertemplate: '',
              type: 'bar',
              marker: {
                color: '#4D50E8',
                line: {
                  color: 'white',
                }
              }
            },
            {
              x: [],
              y: [],
              name: 'Mixed feedback',
              key: 'mixedFeedback',
              hovertemplate: '',
              type: 'bar',
              marker: {
                color: '#4D50E8',
                line: {
                  color: 'white',
                }
              }
            }
          ]
        }
      }
    })
    // console.log(data)
    return data;
  },

  formatPanelChartData: (data, dailyData, panelName, templateData, viewBy, originColors, legendColors) => {
    let mapLagends = {
      customerRequested: 'customer requested',
      programmed: 'programmed',
      contained: 'contained',
      handoff: 'handed off',
      resolved: 'resolved',
      abandoned: 'abandoned',
      messagesUnderstood: 'messages understood',
      messagesNotUnderstood: 'messages not understood',
      falsePositive: 'false positives',
      correctClassification: 'correct classification',
      longMessages: 'long messages',
      shortMessages: 'short messages',
      positiveFeedback: 'positive feedback',
      negativeFeedback: 'negative feedback',
      noFeedback: 'no feedback',
      returningCustomers: 'returning customers',
      newCustomers: 'new customers',
      mixedFeedback: 'mixed feedback',
      LCOnly: 'LC Only',
    }
    let startPeriodObj = {};
    templateData.data.forEach((sectionData, sectionDataIndex)=>{
      //reset
      if(sectionData.lineChartData) {
        sectionData.lineChartData.xAxisData = [];
        sectionData.lineChartData.yAxisData = [];
      }
      if(sectionData.columnChartData && sectionData.columnChartData.traceData.length > 0) {
        sectionData.columnChartData.traceData.forEach(trace => {
          trace.x = [];
          trace.y = [];
          trace.z = [];
          trace.hovertext = [];
        })
      }
      // Prepare Overview data
      if(sectionData.isTimeUnit) {
        sectionData.value = WyUtils.toNiceTimeFormat(data[panelName][sectionData.key]/1000);
        sectionData.displayValue = WyUtils.toNiceTimeFormat(data[panelName][sectionData.key]/1000);
      }
      else {
        
        sectionData.value = data[panelName][sectionData.key];
        sectionData.displayValue = WyUtils.bigNumberFormatter(data[panelName][sectionData.key]);
      }
      
      // Prepare comparation data
      if(data[panelName][sectionData.key + 'LineChartData']) {
        startPeriodObj = WyPanelUtils.startPeriodCalculation(dailyData[panelName][sectionData.key + 'LineChartData'], sectionData.key);
      }
      else {
        startPeriodObj = WyPanelUtils.startPeriodColumnChartCalculation(dailyData[panelName][sectionData.key + 'BarChartData']);
      }
      if(sectionData.isTimeUnit) {
        sectionData.daysPreviousValue = WyUtils.toNiceTimeFormat(data[panelName][panelName + 'Overtime']['daysPrevious' + sectionData.suffixKey]/1000);
        // console.log(startPeriodObj.startValue)
        sectionData.startPeriodValue =  WyUtils.toNiceTimeFormat(parseInt(startPeriodObj.startValue * 60));
        sectionData.endPeriodValue =  WyUtils.toNiceTimeFormat(parseInt(startPeriodObj.endValue * 60));
      }
      else {
        sectionData.daysPreviousValue = data[panelName][panelName + 'Overtime']['daysPrevious' + sectionData.suffixKey];
        sectionData.startPeriodValue = startPeriodObj.startValue;
        sectionData.endPeriodValue =  startPeriodObj.endValue;
      }
      sectionData.changeOver30Days = data[panelName][panelName + 'Overtime']['daysOvertimeRange' + sectionData.suffixKey];
      sectionData.daysOvertimeRange = data[panelName][panelName + 'Overtime'].daysOvertimeRange;
      sectionData.changeFromStart = startPeriodObj.diffPercentage;
  
      // Prepare Trend Graph data  
      sectionData.trendGraph = data[panelName][sectionData.key + 'TrendGraph'];
  
      if(data[panelName][sectionData.key + 'LineChartData']) {
        sectionData.lineChartData.legendColors = originColors;
        data[panelName][sectionData.key + 'LineChartData'].forEach((item, charDataIndex) => {
          if(data[panelName][sectionData.key + 'LineChartData'].length == 1) {
            switch (viewBy) {
              case 'day':
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM DD YYYY");
                break;
              case 'year':
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("YYYY");
                break;
              default:
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM YYYY");
            }
          }
          else {
            switch (viewBy) {
              case 'day':
                sectionData.lineChartData.xAxisData[charDataIndex] = item.date;
                break;
              case 'week':
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM DD YYYY");
                break;
              case 'month':
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM YYYY");
                break;
              case 'year':
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("YYYY");
                break;
              default:
                sectionData.lineChartData.xAxisData[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM YYYY");
            }
          }
          sectionData.lineChartData.yAxisData[charDataIndex] = Math.round(item[sectionData.key] * 100) / 100;
        })
      }
      //Prepare Bar chart data

      let colors = originColors;
      if(data[panelName][sectionData.key + 'BarChartData']) {
        if(data[panelName][sectionData.key + 'PieChartLegendKeys']) {
          data[panelName][sectionData.key + 'PieChartLegendKeys'].forEach((key, legendIndex)=>{
            data[panelName][sectionData.key + 'BarChartData'].forEach((item, charDataIndex) => {
              let traceLength = sectionData.columnChartData.traceData.length;
              if(traceLength > 0) {
                sectionData.columnChartData.traceData.forEach((traceData) => {
                  if(traceData.key == key) {
                    // if(data[panelName].fieldList) {
                    //   const foundField = data[panelName].fieldList.find(el => el.key==traceData.key);
                    //   if(foundField) {
                    //     traceData.legend = foundField.label
                    //   }
                    //   else {
                    //     traceData.legend = key;
                    //   }
                    // }
                    // else if(mapLagends[key]) {
                    //   traceData.legend = mapLagends[key];
                    // }
                    // else {
                    //   traceData.legend = key;
                    // }
                    if(data[panelName][sectionData.key + 'BarChartData'].length == 1) {
                      switch (viewBy) {
                        case 'day':
                          // sectionData.lineChartData.xAxisData[charDataIndex] = item.date;
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM DD YYYY");
                          break;
                        case 'year':
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("YYYY")
                          break;
                        default:
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM YYYY")
                      }
                    }
                    else {
                      switch (viewBy) {
                        case 'day':
                          traceData.x[charDataIndex] = item.date;
                          break;
                        case 'week':
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM DD YYYY");
                          traceData.z[charDataIndex] = item.toolTipsRange;
                          break;
                        case 'month':
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM YYYY")
                          break;
                        case 'year':
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("YYYY")
                          break;
                        default:
                          traceData.x[charDataIndex] = moment(item.date,'YYYY-MM-D').format("MMM YYYY")
                      }
                    }
                    traceData.y[charDataIndex] = item[traceData['key']];
                    if(item.total > 0) {
                      traceData.hovertext[charDataIndex] = (item[traceData['key']]/item.total * 100).toFixed(1);
                    }
                    else {
                      traceData.hovertext[charDataIndex] = 0
                    }
  
                    if(traceData.hovertemplate == '') {
                      if(templateData.legends && sectionDataIndex == 0) {
                        if(legendColors) {
                          colors = legendColors
                        }
                        traceData.hovertemplate = " " + templateData.legends[legendIndex] + " <br> %{y:,}" + " (" + "%{hovertext:.}" + "%)"
                      }
                      else {
                        if(mapLagends[key]) {
                          traceData.hovertemplate = " " + mapLagends[key] + " <br> %{y:,}" + " (" + "%{hovertext:.}" + "%)"
                        }
                        else {
                          traceData.hovertemplate = " " + key + " <br> %{y:,}" + " (" + "%{hovertext:.}" + "%)"
                        }
                      }
                      
                    }
                    traceData.name =''
                    traceData.marker = {
                      color: colors[legendIndex], 
                      line: {
                        color: 'white', 
                        width: 0.5,
                      }
                    }
                  }
                })
              }
            })
          })
        }
      }
      //Prepare Pie chart data
      if(data[panelName][sectionData.key + 'PieChartData']) {
        sectionData.pieChartData.displayValue = 0;
        sectionData.pieChartData.percent = [];
        sectionData.pieChartData.values = [];
        if(data[panelName][sectionData.key + 'PieChartLegendKeys']) {
          let legends = [];
          if(templateData.legends && sectionDataIndex == 0) {
            legends = templateData.legends;
          }
          else {
            data[panelName][sectionData.key + 'PieChartLegendKeys'].forEach(key => {
              if(mapLagends[key]) {
                legends.push(mapLagends[key]);
              }
              else {
                legends.push(key);
              }
            })
          }
          
          sectionData.pieChartData.legends = legends;
        }
        data[panelName][sectionData.key + 'PieChartLegendKeys'].forEach(key => {
          // console.log(pieData)
          data[panelName][sectionData.key + 'PieChartData'].forEach(pieData => {
            if(pieData.item == key) {
              if(sectionData.pieChartData.suffix){
                sectionData.pieChartData.displayValue = data[panelName][sectionData.key] + sectionData.pieChartData.suffix;
              }
              else {
                sectionData.pieChartData.displayValue = data[panelName][sectionData.key];
              }
              sectionData.pieChartData.percent.push(pieData.percent);
              sectionData.pieChartData.values.push(pieData.volume);
            }
          })
        })
        sectionData.pieChartData.legendColors = colors;
      }
      if(sectionData.columnChartData) {
        //filter out useless trace data
        let availableKeys = data[panelName][sectionData.key + 'PieChartLegendKeys'];
        sectionData.columnChartData.traceData = sectionData.columnChartData.traceData.filter(traceData => { return availableKeys.includes(traceData.key)})
      }
    })
    templateData.groupByRawData = data;
    templateData.dailyRawData = dailyData;
    return templateData;
  },

  arverageGroupBy: (viewBy, ChartData, fieldNames) => {
    let dateStart = moment(ChartData[0].date);
    let dateEnd = moment(ChartData[ChartData.length-1].date);
    wyChart.init(viewBy, dateStart, dateEnd);
    ChartData.forEach(el => {
      wyChart.prepareGroupDates(el, el.date);
    })
    
    ChartData = wyChart.groupBy(ChartData, (items) => {
      let obj = {date: items[0].date};
      let dateRange = '';
      dateRange = moment(items[0].date,'YYYY-MM-D').format("MMM DD YYYY");
      if(viewBy == 'week') {
        if(items.length > 1) {
          dateRange = dateRange + ' - ' + moment(items[items.length - 1].date,'YYYY-MM-D').format("MMM DD YYYY");
        }
      }
      fieldNames.forEach(fieldName => {
        obj[fieldName] = _.sumBy(items, fieldName)/items.length;
        obj.toolTipsRange = dateRange;
      })
      return obj
    })
    return ChartData
  },

  arverageGroupByMinusOneCase: (viewBy, ChartData, fieldNames) => {
    let dateStart = moment(ChartData[0].date);
    let dateEnd = moment(ChartData[ChartData.length-1].date);
    wyChart.init(viewBy, dateStart, dateEnd);
    ChartData.forEach(el => {
      wyChart.prepareGroupDates(el, el.date);
    })
    
    ChartData = wyChart.groupBy(ChartData, (items) => {
      let obj = {date: items[0].date};
      let dateRange = '';
      dateRange = moment(items[0].date,'YYYY-MM-D').format("MMM DD YYYY");
      if(viewBy == 'week') {
        if(items.length > 1) {
          dateRange = dateRange + ' - ' + moment(items[items.length - 1].date,'YYYY-MM-D').format("MMM DD YYYY");
        }
      }
      fieldNames.forEach(fieldName => {
        WyPanelUtils.averageWithNoData(items, fieldName, obj)
        obj.toolTipsRange = dateRange;
      })
      return obj
    })
    return ChartData
  },

  averageWithNoData: (items, fieldName, obj) => {
    let excludeLength = 0;
    items.forEach((item, index) => {
      if(item[fieldName] == -1) {
        excludeLength ++
        items[index][fieldName] = 0;
      }
    })
    let length = items.length - excludeLength;
    if(length > 0) {
      obj[fieldName] = _.sumBy(items, fieldName)/length;
    }
    else {
      obj[fieldName] = -1
    }
  },
  
  arverageTimeGroupBy: (viewBy, ChartData, fieldNames) => {
    let dateStart = moment(ChartData[0].date);
    let dateEnd = moment(ChartData[ChartData.length-1].date);
    wyChart.init(viewBy, dateStart, dateEnd);
    ChartData.forEach(el => {
      wyChart.prepareGroupDates(el, el.date);
    })
    
    ChartData = wyChart.groupBy(ChartData, (items) => {
      let obj = {date: items[0].date};
      let dateRange = '';
      dateRange = moment(items[0].date,'YYYY-MM-D').format("MMM DD YYYY");
      if(viewBy == 'week') {
        if(items.length > 1) {
          dateRange = dateRange + ' - ' + moment(items[items.length - 1].date,'YYYY-MM-D').format("MMM DD YYYY");
        }
      }
      fieldNames.forEach(fieldName => {
        obj[fieldName] = _.sumBy(items, fieldName)/items.length/60000;
        obj.toolTipsRange = dateRange;
      })
      return obj
    })
    return ChartData
  },
  
  totalVolumGroupBy: (viewBy, ChartData, fieldNames) => {
    let dateStart = moment(ChartData[0].date);
    let dateEnd = moment(ChartData[ChartData.length-1].date);
    wyChart.init(viewBy, dateStart, dateEnd);
    ChartData.forEach(el => {
      wyChart.prepareGroupDates(el, el.date);
    })
    ChartData = wyChart.groupBy(ChartData, (items) => {
      let obj = {date: items[0].date, total: 0};
      let dateRange = '';
      dateRange = moment(items[0].date,'YYYY-MM-D').format("MMM DD YYYY");
      if(viewBy == 'week') {
        if(items.length > 1) {
          dateRange = dateRange + ' - ' + moment(items[items.length - 1].date,'YYYY-MM-D').format("MMM DD YYYY");
        }
      }
      fieldNames.forEach(fieldName => {
        obj[fieldName] = _.sumBy(items, fieldName);
        obj.toolTipsRange = dateRange;
        obj.total = obj.total + _.sumBy(items, fieldName);
      })
      return obj
    })
    return ChartData
  },

  totalVolumGroupByMinusOneCase: (viewBy, ChartData, fieldNames) => {
    let dateStart = moment(ChartData[0].date);
    let dateEnd = moment(ChartData[ChartData.length-1].date);
    wyChart.init(viewBy, dateStart, dateEnd);
    ChartData.forEach(el => {
      wyChart.prepareGroupDates(el, el.date);
    })
    ChartData = wyChart.groupBy(ChartData, (items) => {
      let obj = {date: items[0].date, total: 0};
      let dateRange = '';
      dateRange = moment(items[0].date,'YYYY-MM-D').format("MMM DD YYYY");
      if(viewBy == 'week') {
        if(items.length > 1) {
          dateRange = dateRange + ' - ' + moment(items[items.length - 1].date,'YYYY-MM-D').format("MMM DD YYYY");
        }
      }
      let nodata = true;
      fieldNames.forEach(fieldName => {
        WyPanelUtils.sumByWithNoData(items, fieldName, obj);
        obj.toolTipsRange = dateRange;
        if(obj[fieldName] > -1) {
          nodata = false;
          obj.total = obj.total + obj[fieldName];
        }
      })
      if(nodata) {
        obj.total = -1;
      }
      return obj
    })
    return ChartData
  },

  sumByWithNoData: (items, fieldName, obj) => {
    let excludeLength = 0;
    items.forEach((item, index) => {
      if(item[fieldName] == -1) {
        excludeLength ++
        items[index][fieldName] = 0;
      }
    })
    let length = items.length - excludeLength;
    if(length > 0) {
      obj[fieldName] = _.sumBy(items, fieldName);
    }
    else {
      obj[fieldName] = -1
    }
  },
  
  generateUsagePerCustomerGroupByData: (viewBy, templateData, infos, tabData, pieChartData) => {
    templateData.filterSettings.buckets.forEach((bucket) => {
      if(tabData.key == bucket.key) {
        let groupByFieldNames = [];
        let legends = [];
        let fieldsLength = bucket.numberRange.length;
        bucket.numberRange.forEach((numberRange, index) => {
          if(index == 0) {
            let firstFieldName = '';
            firstFieldName = '<' + numberRange.endNumber + " conv";
            legends.push(firstFieldName);
            groupByFieldNames.push(firstFieldName);
          }
          else {
            if(index == fieldsLength - 1) {
              let lastFieldName = numberRange.startNumber + "+ conv";
              legends.push(lastFieldName);
              groupByFieldNames.push(lastFieldName);
            }
            else {
              let fieldName = numberRange.startNumber + "" + " - " + numberRange.endNumber + " conv";
              legends.push(fieldName);
              groupByFieldNames.push(fieldName);
            }
          }
        })
        groupByFieldNames.forEach(groupByFieldName => {
          tabData[groupByFieldName] = 0
          tabData.legends = legends;
        })
        infos.forEach((info) => {
          // let mapping = {
          //   averageHandlingTime: 'handlingTime',
          //   averageResponseTime: 'responseTime',
          //   averageWaitTime: 'waitTime'
          // }
          // let bucket = templateData.filterSettings.buckets[tabDataIndex]
          let conversationNumber = info.numOfConversations;
          // totalNumber = totalNumber + conversationNumber;
          bucket.numberRange.forEach((numberRange, index) => {
            if(index == 0) {
              if(conversationNumber <= numberRange.endNumber) {
                tabData[groupByFieldNames[index]] = tabData[groupByFieldNames[index]] + info.users;
              }
            }
            else {
              if(index == fieldsLength - 1) {
                if(conversationNumber > numberRange.startNumber) {
                  tabData[groupByFieldNames[index]] = tabData[groupByFieldNames[index]] + info.users;
                }
              }
              else {
                if(conversationNumber > numberRange.startNumber && conversationNumber <= numberRange.endNumber) {
                  tabData[groupByFieldNames[index]] = tabData[groupByFieldNames[index]] + info.users;
                }
              }
            }
          })
        })
        if(Object.keys(pieChartData).length == 0) {
          groupByFieldNames.forEach(fieldName => {
            pieChartData[fieldName] = tabData[fieldName];
          })
        }
        else {
          groupByFieldNames.forEach(fieldName => {
            pieChartData[fieldName] = pieChartData[fieldName] + tabData[fieldName];
          })
        }
      }
    })
    // console.log("tabData", tabData)
    return tabData
  },
  
  generateHandlingTimesGroupByData: (viewBy, templateData, conversations, tabData, pieChartData) => {
    templateData.filterSettings.buckets.forEach((bucket) => {
      if(tabData.key == bucket.key) {
        let groupByFieldNames = [];
        let legends = [];
        let fieldsLength = bucket.numberRange.length;
        bucket.numberRange.forEach((numberRange, index) => {
          if(index == 0) {
            let firstFieldName = '<' + numberRange.endNumber + " m";
            legends.push(firstFieldName);
            groupByFieldNames.push(firstFieldName);
          }
          else {
            if(index == fieldsLength - 1) {
              let lastFieldName = numberRange.startNumber + "+ m ";
              legends.push(lastFieldName);
              groupByFieldNames.push(lastFieldName);
            }
            else {
              let fieldName = numberRange.startNumber + " m" + " - " + numberRange.endNumber + " m";
              legends.push(fieldName);
              groupByFieldNames.push(fieldName);
            }
          }
        })
        groupByFieldNames.forEach(groupByFieldName => {
          tabData[groupByFieldName] = 0
          tabData.legends = legends;
        })
        conversations.forEach((conversation) => {
          let mapping = {
            averageHandlingTime: 'handlingTime',
            averageResponseTime: 'responseTime',
            averageWaitTime: 'waitTime',
            averageBotTime: 'botTime'
          }
          // let bucket = templateData.filterSettings.buckets[tabDataIndex]
          let timePerConversation = conversation[mapping[bucket.key]];
          bucket.numberRange.forEach((numberRange, index) => {
            if(index == 0) {
              if(timePerConversation < numberRange.endNumber * 60 * 1000) {
                tabData[groupByFieldNames[index]] = tabData[groupByFieldNames[index]] + 1
              }
            }
            else {
              if(index == fieldsLength - 1) {
                if(timePerConversation >= numberRange.startNumber * 60 * 1000) {
                  tabData[groupByFieldNames[index]] = tabData[groupByFieldNames[index]] + 1
                }
              }
              else {
                if(timePerConversation >= numberRange.startNumber * 60 * 1000 && timePerConversation < numberRange.endNumber * 60 * 1000) {
                  tabData[groupByFieldNames[index]] = tabData[groupByFieldNames[index]] + 1
                }
              }
            }
          })
        })
  
        if(Object.keys(pieChartData).length == 0) {
          groupByFieldNames.forEach(fieldName => {
            pieChartData[fieldName] = tabData[fieldName];
          })
        }
        else {
          groupByFieldNames.forEach(fieldName => {
            pieChartData[fieldName] = pieChartData[fieldName] + tabData[fieldName];
          })
        }
        // console.log(">>>>>>>>>>>>>>>>>",tabData, pieChartData)
      }
    })
    return tabData
  },

  startPeriodCalculation: (list, propName) => {
    let obj = {};
    if(list) {
      if(list.length < 7) {
        let total = 0;
        list.forEach(item => {
          total = total + item[propName]
        })
        obj.startValue = 'N/A';
        obj.endValue = 'N/A';
        obj.diffPercentage = 'N/A'
      }
      else {
        // let reversList = list.reverse();
        let total = 0;
        for(let i = list.length - 1; i > list.length - 8; i--) {
          total = total + list[i][propName]
          // console.log("curr", list[i][propName], total)
        }
        obj.endValue = total / 7;
        total = 0;
        for(let i = 0; i < 7; i++) {
          total = total + list[i][propName]
          // console.log("pre",list[i][propName], total)
        }
        let preStartValue = total / 7;
        obj.startValue = preStartValue;
        obj.diffPercentage = Number(WyUtils.calculatePercentage(obj.startValue, obj.endValue))
        // console.log(obj.endValue, obj.startValue, (obj.endValue - obj.startValue)/obj.startValue)
      }
    }
    return obj
  },
  
  startPeriodColumnChartCalculation: (list) => {
    let obj = {};
    if(list) {
      if(list.length < 7) {
        obj.startValue = 'N/A';
        obj.endValue = 'N/A';
        obj.diffPercentage = 'N/A'
      }
      else {
        // let reversList = list.reverse();
        let total = 0;
        for(let i = list.length - 1; i > list.length - 8; i--) {
          Object.keys(list[i]).forEach(key => {
            if(key != 'date') {
              total = total + list[i][key]
            }
          })
          // console.log("curr", list[i], total)
        }
        obj.endValue = total / 7;
        total = 0;
        for(let i = 0; i < 7; i++) {
          Object.keys(list[i]).forEach(key => {
            if(key != 'date') {
              total = total + list[i][key]
            }
          })
          // console.log("pre",list[i], total)
        }
        obj.startValue = total / 7;
        obj.diffPercentage = Number(WyUtils.calculatePercentage(obj.startValue, obj.endValue))
      }
    }
    return obj
  },

  preparePieData: (data) => {
    let pieChartData = [];
    Object.keys(data).forEach( fieldName => {
      let obj = {};
      obj.item = fieldName;
      obj.volume = data[fieldName];
      pieChartData.push(obj);
    })
    return pieChartData;
  },
  
  dynamicCreateTraceData: (fieldList) => {
    // templateData.data.forEach((sectionData)=>{
    // })
    let traceData = [];
    fieldList.forEach(field => {
      let trace = {
        x: [],
        y: [],
        name: field,
        key: field,
        type: 'bar',
        hovertemplate: '',
        marker: {
          color: '#0C2837',
          line: {
              color: 'white'
          }
        }
      }
      traceData.push(trace)
    })
    return traceData;
  },

  getLegendColor(originList, originColorList, legendList) {
    let colors = [];
    if(originColorList.length < legendList.length) {
      originColorList = this.generateRandomColors(100, originColorList)
    }
    legendList.forEach(legend => {
      let index = _.indexOf(originList, legend)
      if(index > -1) {
        if(index > originColorList.length - 1) {
          colors.push(originColorList[originColorList.length - 1])
        }
        else {
          colors.push(originColorList[_.indexOf(originList, legend)])
        }
      }
    })
    let returnColors = colors
    let noExistIndex = 0;
    legendList.forEach(legend => {
      let index = _.indexOf(originList, legend)
      if(index == -1) {
        index = _.indexOf(originColorList, returnColors[returnColors.length - 1])
        if(originList.length + noExistIndex >= originColorList.length - 1) {
          returnColors.push(originColorList[originColorList.length - 1])
        }
        else {
          returnColors.push(originColorList[originList.length + noExistIndex])
        }
        noExistIndex ++;
      }
    })
    // console.log(returnColors)
    return returnColors;
  },

  mergeList(originList, incomingList) {
    return _.uniq(_.concat(originList, incomingList));
  },

  updateFieldList(originList, fieldList) {
    let newLegendList = []
    originList.forEach(item => {
      fieldList.forEach(legend => {
        if(item == legend) {
          newLegendList.push(item)
        }
      })
    })
    return _.uniq(_.concat(newLegendList, fieldList));
  },

  updateFieldObjectList(fieldObjectList, fieldList) {
    let newFieldObjectList = [];
    fieldList.forEach(field=>{
      fieldObjectList.forEach(fieldObj => {
        if(fieldObj.prefix == field) {
          newFieldObjectList.push(fieldObj)
        }
      })
    })
    return newFieldObjectList;
  },

  generateRandomColors(colorNum, colors) {
    for (let i = 0; i < colorNum; i++){ 
      let color = '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'); // NOSONAR
      if(colors.indexOf(color)==-1)
      {
        colors.push(color)
      }else {
        i--
      }
    }
    return colors
  },

  changeTimeFormat(list, fieldName) {
    list.forEach(item => {
      item[fieldName] = item[fieldName] / 60000
    })
    // console.log(list)
    return list
  }
};

export default WyPanelUtils;